import React from 'react';

export default translationsStore => ({
  title: translationsStore.translate('lead.table.column.client'),
  dataIndex: 'client',
  render: (text, record) => <span style={{ textTransform: 'capitalize' }}>{record.client.fullName.toLowerCase()}</span>
});
